const InProgressTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FFF6ED" />
      <path
        d="M18.9168 15.1667C18.9168 13.5558 17.611 12.25 16.0002 12.25C14.3893 12.25 13.0835 13.5558 13.0835 15.1667C13.0835 16.7775 14.3893 18.0833 16.0002 18.0833C17.611 18.0833 18.9168 16.7775 18.9168 15.1667Z"
        stroke="#FC8415"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.9022 15.4583C19.1705 15.5396 19.4551 15.5833 19.7499 15.5833C21.3607 15.5833 22.6666 14.2775 22.6666 12.6667C22.6666 11.0558 21.3607 9.75 19.7499 9.75C18.2375 9.75 16.9939 10.9012 16.8477 12.3751"
        stroke="#FC8415"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1524 12.3751C15.0062 10.9012 13.7626 9.75 12.2502 9.75C10.6393 9.75 9.3335 11.0558 9.3335 12.6667C9.3335 14.2775 10.6393 15.5833 12.2502 15.5833C12.545 15.5833 12.8296 15.5396 13.0979 15.4583"
        stroke="#FC8415"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.3333 19.7499C24.3333 17.4488 22.2813 15.5833 19.75 15.5833"
        stroke="#FC8415"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5832 22.2499C20.5832 19.9488 18.5312 18.0833 15.9998 18.0833C13.4685 18.0833 11.4165 19.9488 11.4165 22.2499"
        stroke="#FC8415"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2498 15.5833C9.71853 15.5833 7.6665 17.4488 7.6665 19.7499"
        stroke="#FC8415"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default InProgressTicketIcon;
